import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type BurgerQuicklinksContainerProps = {
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const BurgerQuicklinksContainer = memo(({templating}: BurgerQuicklinksContainerProps) => {
    const TemplatedBurgerQuickLinks = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <TemplatedBurgerQuickLinks />
        </Suspense>
    )
})
BurgerQuicklinksContainer.displayName = "BurgerQuicklinksContainer"
export default connect(BurgerQuicklinksContainer)
